import React, { useMemo, useState } from 'react';
import '../styles/services.css';
import '../packages-v2/packages-v2.css';
import PackageCircleCard from '../packages-v2/PackageCircleCard';
import { useNavigate } from 'react-router-dom';
import ActionButton from '../../../shared/components/action-button/ActionButton';
import { getServicePathSegment } from '../utils/serviceSlug';


const PackagesPage = ({ service }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortKey, setSortKey] = useState('name_asc');

  const handleAddNew = () => {
    if (!service?.id) return;
    navigate(`/app/overview/services/${getServicePathSegment(service)}/packages/new`);
  };

  const handleEdit = (packageItem) => {
    if (!service?.id || !packageItem?.id) return;
    navigate(`/app/overview/services/${getServicePathSegment(service)}/packages/${packageItem.id}`);
  };

  const visiblePackages = useMemo(() => {
    const list = Array.isArray(service?.packages) ? [...service.packages] : [];
    const q = searchTerm.trim().toLowerCase();
    const filtered = q ? list.filter((p) => String(p?.name || '').toLowerCase().includes(q)) : list;

    const toMs = (v) => {
      const ms = Date.parse(String(v || ''));
      return Number.isFinite(ms) ? ms : 0;
    };

    filtered.sort((a, b) => {
      if (sortKey === 'name_desc') return String(b?.name || '').localeCompare(String(a?.name || ''));
      if (sortKey === 'price_desc') return Number(b?.price || 0) - Number(a?.price || 0);
      if (sortKey === 'updated_desc') return toMs(b?.updatedAt) - toMs(a?.updatedAt);
      return String(a?.name || '').localeCompare(String(b?.name || ''));
    });

    return filtered;
  }, [service?.packages, searchTerm, sortKey]);

  return (
    <div className="svc-page">
      <>
          <div className="pkg2-toolbar">
            <div className="pkg2-left">
              <input
                className="pkg2-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search packages…"
                aria-label="Search packages"
              />
              <select className="pkg2-select" value={sortKey} onChange={(e) => setSortKey(e.target.value)} aria-label="Sort packages">
                <option value="name_asc">Sort: Name (A–Z)</option>
                <option value="name_desc">Sort: Name (Z–A)</option>
                <option value="price_desc">Sort: Price (High → Low)</option>
                <option value="updated_desc">Sort: Recently updated</option>
              </select>
            </div>
            <ActionButton variant="primary" onClick={handleAddNew}>
              New Package
            </ActionButton>
          </div>

          {visiblePackages.length === 0 ? (
            <div className="svc-empty">
              <div style={{ fontWeight: 700, marginBottom: 6 }}>No Packages Yet</div>
              <div style={{ color: 'var(--text-500)' }}>Start by adding your first service package.</div>
            </div>
          ) : (
            <div className="pkg2-circleGrid">
              {visiblePackages.map((packageItem, index) => (
                <PackageCircleCard
                  key={packageItem.id || packageItem.name || index}
                  pkg={packageItem}
                  onOpen={() => handleEdit(packageItem)}
                />
              ))}
            </div>
          )}
        </>
    </div>
  );
};

export default PackagesPage; 